import { useId, type ReactNode } from "react";
import { IconChevronRight } from "./icons";

/*
 * Карточки окон настроек по макету v6 — у человека, сервера и канала одни и
 * те же: раздел обведён кольцом стекла, строки — подпись слева и управление
 * справа.
 */

/**
 * Раздел-карточка, как в макете v6: обведён кольцом стекла и подписан
 * заголовком. Признак `data-sec` — для настроек человека: там колонка
 * разделов показывает, у какой карточки сейчас прокрутка.
 */
export function Card({ title, children }: { title: string; children: ReactNode }) {
  const id = useId();

  return (
    <section className="set-card" data-sec="" aria-labelledby={id}>
      <h3 id={id} className="set-card-title">
        {title}
      </h3>
      {children}
    </section>
  );
}

/**
 * Строка карточки: подпись с пояснением слева, управление справа.
 *
 * `plan` гасит строку и ставит пометку: место под возможность занято, а её
 * самой в API пока нет. `muted` только гасит — возможность есть, но не у
 * этого человека. `label` делает строку подписью выключателя справа:
 * нажатие на текст переключает его, как и прежде в `switch-row`.
 */
export function Row({
  title,
  note,
  plan,
  muted,
  label,
  children,
}: {
  title: ReactNode;
  note?: ReactNode;
  plan?: boolean;
  muted?: boolean;
  label?: boolean;
  children?: ReactNode;
}) {
  const Box = label ? "label" : "div";

  return (
    <Box className={`set-row ${plan || muted ? "muted-row" : ""} ${label ? "set-row-label" : ""}`}>
      <span className="set-row-text">
        <span className="set-row-title">
          {title}
          {plan && <span className="plan-tag">план</span>}
        </span>
        {note && <span className="set-row-note">{note}</span>}
      </span>
      {children}
    </Box>
  );
}

/**
 * Строка-переход: вся строка — кнопка со стрелкой справа, как «Активные
 * сеансы» в макете. С `plan` она гаснет и не нажимается.
 */
export function Go({
  title,
  value,
  plan,
  onClick,
}: {
  title: ReactNode;
  value?: ReactNode;
  plan?: boolean;
  onClick?: () => void;
}) {
  return (
    <button type="button" className={`set-row set-go ${plan ? "muted-row" : ""}`} disabled={plan} onClick={onClick}>
      <span className="set-row-text">
        <span className="set-row-title">
          {title}
          {plan && <span className="plan-tag">план</span>}
        </span>
      </span>
      {value && <span className="set-value">{value}</span>}
      <IconChevronRight size={16} className="set-go-arrow" />
    </button>
  );
}
